import * as z from 'zod';

import { booleanQuerySchema } from '@/_schemas/generic';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';

import { paymentMethodFieldQuerySchema } from './payment-method-field-query-schema';
import { paymentMethodQueryLinkerSchema } from './payment-method-query-linker-schema';

export const paymentMethodQuerySchema = z.object({
  ...paymentMethodQueryLinkerSchema.shape,
  is_active: booleanQuerySchema(),
  include_for_taking_tender: booleanQuerySchema(),
  include_for_manual_deposit: booleanQuerySchema(),
  payment_method_fields: z.array(paymentMethodFieldQuerySchema).optional(),
});

export type PaymentMethodQuerySchema = z.infer<typeof paymentMethodQuerySchema>;

export const paymentMethodQueryAllSchema = paginatedResponseSchema(paymentMethodQuerySchema);
export type PaymentMethodQueryAllSchema = z.infer<typeof paymentMethodQueryAllSchema>;
